module.exports = __webpack_public_path__ + "static/media/ascentarc-2.a08fd906.jpg";